import React, { Component } from 'react';

import FileViewer from 'react-file-viewer';
import { Box, Grid } from "@material-ui/core";
import axios from 'axios';
//const Path  = require('path');

class Image extends Component {
    
    state = {
        src:"",
        format: "",
        numPages: null,
        pageNumber: 1,
    };
    
    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }
    componentDidMount = async () => {
        let methodName = 'Get Photo';
        let url = "/image/get?imageid=" + this.props.src;
        let src = ""
        let res = await axios.get(url)
        console.log('====================================');
        console.log(methodName, {res});
        console.log('====================================');
        // this.serverRequest = $.get(url, function(result) {
        //     console.log('[INFO], ', methodName);
        //     var src = "";
        //     try {
        //         var data = result; //var data = JSON.parse(result);
        //         //onsole.log(data);
        //         src = data;
        //     } catch (e) {
        //         // les instructions utilisées pour gérer les exceptions
        //         console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
        //         console.log(e); // on transfère l'objet de l'exception à une méthode
        //         return;
        //     }
        if (res.data.error) {
            console.log("ERROR", res.data.error);  
        } else {
            src = res.data
        }
        console.log('[INFO], PATH Val ', this.props.src);
        //let ext = Path.extname(this.props.src)
        let ext = this.props.src.split(".",-1)
        console.log('[INFO], PATH Val ', ext,"",ext.length);

        this.setState({
            src: src,
            format: "."+ext[ext.length-1],
        });
    }
    onError = (e) => {
        console.log('[ERROR], Loading document, ',e)
    }
    render() {
        console.log('Info on photo : ',this.state.format);
        let imgFormat = [".jpeg", ".jpg", ".png", ".gif"]
        return (
            <Grid
                item
                xs={12} sm={6} md={4}
                key={this.props.src} 
                // data-src="image/get?imageid=toto4.jpg"
                
            >
                <Box style={{"height": "100px", "borderRadius": "5px", "border": "1px solid"}}>
                    {imgFormat.includes(this.state.format) ? 
                        <a href={"/download/document/"+this.props.src} download={this.props.src}>
                            {/* <div> */}
                                <img style={{"maxWidth": "100%"}} src={this.state.src} alt={"loading"}/>
                            {/* </div> */}
                        </a>
                    :
                        // <div className="lightbox-item p-item" style={{maxHeight: "400px",overflow: "auto"}}>
                        <a href={"/download/document/"+this.props.src} download={this.props.src}>
                            <FileViewer
                                fileType={this.state.format.substring(1)}
                                filePath={"/download/document/"+this.props.src}
                                onError={this.onError}
                            />
                        </a>
                    }

                </Box>
            </Grid>
        )
    }
}
export default Image;